const flaggedContentFR = {
    "view": {
        "form": {
            "button": {
                "viewDetails": "Voir les détails"
            },
            "message": {
                "releaseHasBeenAddedToWhitelist": "La sortie <strong>{{releaseName}}</strong> a été ajoutée à la liste blanche.",
                "releaseHasFlaggedContent": "La sortie <strong>{{releaseName}}</strong> contient des pistes signalées. Des frais de <strong>15 €</strong> par piste signalée s'appliquent pour la livrer à <strong>Spotify</strong>.<br/><br/> Cliquez sur le bouton ci-dessous pour compléter votre paiement et continuer."
            },
            "modal": {
                "header": {
                    "titleFlaggedTracksDetails": "Détails des pistes signalées",
                    "titleFlaggedTrackPayment": "Paiement de la liste blanche Spotify"
                },
                "body": {
                    "table": {
                        "title": "Les pistes suivantes ont été signalées. Veuillez examiner les détails ci-dessous :",
                        "column": {
                            "name": "Nom de la piste",
                            "flaggedArtist": "Artiste signalé",
                            "payableAmount": "Montant à payer",
                            "paymentStatus": "Statut du paiement"
                        },
                        "label": {
                            "payableAmount": "15 €",
                            "paid": "PAYÉ",
                            "pending": "EN ATTENTE",
                        },
                    },
                    "label": {
                        "processingPayment": "Traitement du paiement...",
                        "paymentSuccessful": "Paiement réussi !",
                        "paymentFailed": "Échec du paiement !"
                    },
                    "message": {
                        "totalPayableAmount": "Pour compléter la livraison de votre sortie à <strong>Spotify</strong>, un dépôt remboursable de <strong>{{totalAmount}} €</strong> est requis. Veuillez accepter les conditions ci-dessous et cliquer sur le bouton <strong>Continuer</strong> pour effectuer votre paiement.",
                        "escrowAmountAgreement": "J'accepte et reconnais qu'un montant séquestre de <strong>{{totalAmount}} €</strong> sera déposé par moi. Ce montant sera conservé jusqu'à la <strong>fin de l'abonnement</strong> et, à condition qu'aucun problème ne survienne, me sera restitué à la fin de cette période. Cependant, si je viole les conditions de cet accord pendant cette période, le montant séquestre sera appliqué à la facture en souffrance et ne sera pas remboursé. En continuant, j'affirme ma compréhension et mon acceptation de ces conditions.",
                        "escrowPaymentRejected": "Je n'accepte pas les conditions de paiement séquestre et, en conséquence, reconnais que ma sortie <strong>{{releaseName}}</strong> ne sera <strong>pas distribuée sur Spotify</strong>.",
                        "consentRecordedSuccessfully": "Consentement enregistré avec succès !"
                    }
                },
                "button": {
                    "proceed": "Continuer"
                }
            }
        }
    }
}

export default flaggedContentFR;